"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreadCrumb = void 0;
var React = require("react");
var classNames = require("classnames");
var react_virtualized_auto_sizer_1 = require("react-virtualized-auto-sizer");
var Icon_1 = require("../Icon");
var clipboard_1 = require("../../utils/clipboard");
var Dropdown2_1 = require("../Dropdown2");
var Tooltip_1 = require("../Tooltip");
var translation_1 = require("../../utils/translation");
var BreadCrumb = /** @class */ (function (_super) {
    __extends(BreadCrumb, _super);
    function BreadCrumb(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isCopied: false
        };
        return _this;
    }
    BreadCrumb.prototype.getItems = function () {
        var items = [];
        React.Children.map(this.props.children, function (child) {
            if (child && typeof child === 'object') {
                items.push(child);
            }
        });
        return items;
    };
    BreadCrumb.prototype.handleCopy = function () {
        var items = this.getItems();
        var path = items.map(function (item) { return item.props.children; }).join('/');
        (0, clipboard_1.copy)(path);
        this.setState({ isCopied: true });
        setTimeout(function () {
            this.state.tooltip && this.state.tooltip.update();
        }.bind(this), 100);
        setTimeout(function () {
            this.setState({ isCopied: false });
            setTimeout(function () {
                this.state.tooltip && this.state.tooltip.update();
            }.bind(this), 100);
        }.bind(this), 3000);
    };
    BreadCrumb.prototype.collapseItems = function () {
        if (!this.inner || !this.shadowInner) {
            return;
        }
        var dropdown = this.inner
            .getElementsByClassName('sok-dropdown2')
            .item(0);
        if (!dropdown) {
            return;
        }
        var width = 0;
        var buttons = this.inner.getElementsByClassName('sok-breadcrumb-buttons');
        if (buttons.length) {
            width += buttons.item(0).clientWidth;
        }
        var shadowItems = this.shadowInner.getElementsByClassName('sok-breadcrumb-item');
        var items = this.inner.getElementsByClassName('sok-breadcrumb-item');
        for (var i = 0; i < items.length && i < 2; i++) {
            width += shadowItems.item(i).clientWidth;
        }
        for (var i = items.length - 1; i > 1; i--) {
            width += shadowItems.item(i).clientWidth;
            var item = items.item(i);
            // 36 is the width of dropdown
            if (width <= this.inner.clientWidth - 36 ||
                (width <= this.inner.clientWidth && i === 2)) {
                item.style.display = 'block';
            }
            else {
                item.style.display = 'none';
            }
        }
        if (width > this.inner.clientWidth) {
            dropdown.style.display = 'block';
        }
        else {
            dropdown.style.display = 'none';
        }
    };
    BreadCrumb.prototype.componentDidUpdate = function () {
        this.collapseItems();
    };
    BreadCrumb.prototype.render = function () {
        var _this = this;
        var items = this.getItems();
        return (React.createElement("div", { className: classNames('sok-breadcrumb', this.props.className), style: this.props.style },
            React.createElement("div", { className: "sok-breadcrumb-inner", ref: function (div) { return (_this.inner = div); } },
                items.slice(0, 2).map(function (item, index) { return (React.createElement("span", { key: index, className: "sok-breadcrumb-item" }, item)); }),
                items.length > 2 && (React.createElement(Dropdown2_1.Dropdown2, { className: "sok-breadcrumb-dropdown" },
                    React.createElement("button", { className: "sok-breadcrumb-button" },
                        React.createElement(Icon_1.Icon, { className: "fa-folder" })),
                    React.createElement(Dropdown2_1.Dropdown2Menu, null, items.map(function (item, index) { return (React.createElement(Dropdown2_1.Dropdown2MenuItem, { key: index }, item)); })))),
                items.length > 2 &&
                    items.slice(2).map(function (item, index) { return (React.createElement("span", { key: index, className: "sok-breadcrumb-item" }, item)); }),
                React.createElement("div", { className: "sok-breadcrumb-buttons" },
                    React.createElement(Tooltip_1.Tooltip, { instance: this.state.tooltip, getInstance: function (instance) { return _this.setState({ tooltip: instance }); }, key: 'copy', tipPosition: 'center', content: React.createElement("span", null, (0, translation_1.getLocalization)(this.state.isCopied
                            ? 'components/BreadCrumb/pathCopiedToClipboard'
                            : 'components/BreadCrumb/copyPathToClipboard')) },
                        React.createElement("button", { className: "sok-breadcrumb-button sok-breadcrumb-copy-button", onClick: function () { return _this.handleCopy(); } },
                            React.createElement(Icon_1.Icon, { className: "fa-copy" }))))),
            React.createElement("div", { className: "sok-breadcrumb-shadow-inner", ref: function (div) { return (_this.shadowInner = div); } }, items.map(function (item, index) { return (React.createElement("span", { key: index, className: "sok-breadcrumb-item" }, item)); })),
            React.createElement(react_virtualized_auto_sizer_1.default, null, function () {
                _this.collapseItems();
                return null;
            })));
    };
    return BreadCrumb;
}(React.Component));
exports.BreadCrumb = BreadCrumb;
//# sourceMappingURL=index.js.map